import { render, staticRenderFns } from "./UjoAdd.vue?vue&type=template&id=65008f71&scoped=true"
import script from "./UjoAdd.vue?vue&type=script&lang=js"
export * from "./UjoAdd.vue?vue&type=script&lang=js"
import style0 from "./UjoAdd.vue?vue&type=style&index=0&id=65008f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65008f71",
  null
  
)

export default component.exports